package org.matthewo.recharts.type

import js.objects.unsafeJso

fun SegmentMarker(x: Any, y: Any) = unsafeJso<dynamic> {
    this["x"] = x
    this["y"] = y
}
